export default __webpack_public_path__ + "static/media/inventory-active.0076dfc4.svg";